import { getFormattedPrice } from '@kissui/helpers/src/catalog'

const getStrikethroughPriceElement = component => {
    return component.querySelector('.cb-price-old')
}

const fetchStrikethroughPrice = strikethroughPrice => {
    return getFormattedPrice(strikethroughPrice)
}

export const renderStrikethroughPrice = ({ strikethrough_price }, component) => {
    if (!strikethrough_price) {
        return ''
    }

    fetchStrikethroughPrice(strikethrough_price)
        .then(payload => {
            const element = getStrikethroughPriceElement(component)
            if (!element) {
                return
            }

            element.innerHTML = payload
        })
        .catch(e => {
            console.error(`Error: Component SKU - Strike Through Price  - ${e}`)

            const element = getStrikethroughPriceElement(component)
            if (!element) {
                return
            }

            element.style.display = 'none'
        })

    return `<p class="cb-price-old t-sm-400-sl"></p>`
}
